module.exports = {
    // Comunication Keys
    get: {
        configuration: 'get_configuration',
        results: 'get_results',
    },
    set: {
        configuration: 'set_configuration',
        score: 'set_score',
        results: 'set_results',
    },
    exit: 'exit',
    completed: 'completed',
}